var map = {
	"./DIFFmemories.png": 10640,
	"./glclusters.gif": 66103,
	"./glmap.png": 41731,
	"./header_image_2025.png": 92419,
	"./kwachas.png": 54496,
	"./malawi.png": 95723,
	"./monetarybase.png": 57258,
	"./naturalgas.png": 42262,
	"./powershoring.png": 67823,
	"./sanjuanpopulation.png": 8635,
	"./tradedata.png": 65504,
	"./treemap.gif": 48415,
	"./waterintensity.png": 6568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96118;